import React, { useState, useEffect } from "react";
import {ReactTyped} from "react-typed"; // Corrected import
import Herosection from "./Herosection"; // Added missing import

const BrickPattern = ({ isCut }) => (
  <div className="grid grid-cols-4 gap-1 transition-opacity duration-1000 fade-out">
    {Array.from({ length: 48 }).map((_, index) => (
      <div
        key={index}
        className={`w-${isCut ? "10" : "20"} h-8 bg-black border border-white ${index % 8 >= 4 ? "translate-x-1/2" : ""} opacity-50`}
      />
    ))}
  </div>
);

const SvgLine = () => {
  const [brickRows, setBrickRows] = useState(0);
  const [fadeOut, setFadeOut] = useState(false);
  const [textFadeOut, setTextFadeOut] = useState(false);
  const [isCut, setIsCut] = useState(false);
  const [showHero, setShowHero] = useState(false); // Moved this up for consistency

  useEffect(() => {
    const updateBrickRows = () => {
      const rows = Math.floor(window.innerHeight / 60);
      setBrickRows(Math.max(rows, 4));
      setIsCut(window.innerWidth < 1024);
    };

    updateBrickRows();
    window.addEventListener("resize", updateBrickRows);

    const fadeOutTimer = setTimeout(() => setFadeOut(true), 4000);
    const textFadeTimer = setTimeout(() => setTextFadeOut(true), 5000);
    const heroTimer = setTimeout(() => setShowHero(true), 8000); // Moved this here

    return () => {
      clearTimeout(fadeOutTimer);
      clearTimeout(textFadeTimer);
      clearTimeout(heroTimer);
      window.removeEventListener("resize", updateBrickRows);
    };
  }, []);

  return showHero ? (
    <Herosection />
  ) : (
    <div className={`h-screen w-full bg-black p-4 overflow-hidden relative flex items-center justify-center ${fadeOut ? "fade-to-black" : ""}`}>
      {/* Bricks Background */}
      <div className={`absolute inset-0 grid grid-cols-4 gap-1 transition-opacity duration-1000 ${fadeOut ? "opacity-0" : "opacity-100"}`} style={{ height: "100vh" }}>
        {Array.from({ length: brickRows }).map((_, index) => (
          <BrickPattern key={index} isCut={isCut} />
        ))}
      </div>

      {/* Centered Black Box with Welcome Text */}
      <div className={`absolute w-[100%] h-[200px] text-center bg-black flex flex-col items-center justify-center text-white text-4xl font-bold transition-opacity duration-1000 animate-scaleIn`}>
        <h1 className={`text-4xl p-4 sm:text-5xl md:text-6xl font-bold mb-4 transition-colors duration-1000 ${textFadeOut ? "text-black" : "text-white"}`}>
          Welcome to my Portfolio
        </h1>
        <ReactTyped
          className={`text-xl sm:text-2xl md:text-4xl font-medium transition-colors duration-1000 ${textFadeOut ? "text-black" : "text-[#50C878]"}`}
          strings={["A Journey of Creativity and Code"]}
          typeSpeed={50}
          backSpeed={50}
          backDelay={500}
          loop
          showCursor={true}
          cursorChar="|"
        />
      </div>

      {/* Moving Line with New Path */}
      <div className="absolute inset-0 flex items-center justify-center">
        <svg viewBox="0 0 440 100" xmlns="http://www.w3.org/2000/svg" className="svg-line">
          <rect width="500" height="100"/>
          <path
            d="M 0 50 
              C 30 10, 60 10, 90 50 
              C 110 20, 140 20, 160 50 
              C 180 35, 210 35, 230 60 
              C 250 35, 280 35, 300 60
              C 320 20, 350 20, 370 50
              C 390 25, 420 25, 440 50"
            stroke="white"
            fill="none"
            strokeWidth="1"
          />
        </svg>
      </div>

      <style jsx>{`
        .svg-line {
          position: absolute;
          bottom: 0px;
          opacity: 0;
          animation: fadeInMoveUp 4s ease-in-out forwards;
          animation-delay: 6s;
        }

        @keyframes fadeInMoveUp {
          0% {
            opacity: 0;
            bottom: 0px;
          }
          10% {
            opacity: 1;
          }
          100% {
            opacity: 1;
            bottom: 100vh;
          }
        }

        @keyframes scaleIn {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }

        .animate-scaleIn {
          animation: scaleIn 1s ease-in-out forwards;
          animation-delay: 0.5s;
        }

        .fade-to-black {
          background-color: black;
          transition: background-color 1s ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default SvgLine;